<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import moment from "moment";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/es';
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, DatePicker },
    data() {
        return {
            title: "Agregar Laborante de Apoyo Oficina",
            items: [
                {
                text: "Laborantes",
                href: "/"
                },
                {
                text: "Agregar apoyo",
                active: true
                }
            ],
            laborantes:[],
            laborante:null,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            apoyo:[
                {
                    laborante:[],
                    hora_inicio:'',
                    hora_fin:'',
                    fecha:'',
                    comentario:'',
                    laborante_id:''
                }
            ],
            laborantes_apoyo:[],
            liquido:0
        };
    },
    computed:{
        filteredData() {
            // Filtramos los datos en base al campo 'filtro' 
            return this.laborantes_apoyo.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                return (
                    item.rut.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.name.toLowerCase().includes(this.filtro.toLowerCase())
                );
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalRows() {
            return this.filteredData.length;
        },
    },
    watch:{
        // Observar cambios en el array completo
        apoyo: {
            handler() {
                this.verificarCampos_apoyo();
            },
            deep: true // Para detectar cambios en los objetos dentro del array
        },
    },
    methods:{
        verificarCampos_apoyo() {
            this.apoyo.forEach((lab, index) => {
                // Validamos que todos los campos estén presentes
                if (lab.laborante && lab.hora_inicio && lab.hora_fin && lab.fecha) {
                    // Aseguramos obtener el ID del laborante
                    const laborante_id = lab.laborante.id || lab.laborante_id;
                    if (!laborante_id) {
                        this.msg('error', 'Error: El laborante seleccionado no tiene ID.');
                        return;
                    }
                    // Crear los datos del formulario para enviar al backend
                    const formData = new FormData();
                    formData.append('laborante_id', laborante_id);
                    formData.append('fecha', lab.fecha);
                    formData.append('hora_inicio', lab.hora_inicio);
                    formData.append('hora_fin', lab.hora_fin);
                    // Llamada al backend para verificar choque
                    axios.post('/api/revisar_choque_horario_laborante', formData).then(response => {
                        if (!response.data.estado) {
                            this.msg('error', 'El laborante ya tiene horas asignadas en este horario.');
                            console.log('El laborante ya tiene horas asignadas en este horario.');
                            lab.hora_inicio = '';
                            lab.hora_fin = '';
                        }
                    })
                    .catch(() => {
                        this.msg('error', 'Error al verificar choque de horario.');
                        console.log('Error al verificar choque de horario.');
                        
                    });
                }
            });
        },
        labelselect_laborante ({ name }) {
            return `${name}`
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        agregar_lab_apoyo(){
            let a={
                laborante:[],
                hora_inicio:'',
                hora_fin:'',
                fecha:'',
            };
            this.apoyo.push(a);
        },
        eliminar_apoyo(index){
            this.apoyo.splice(index, 1);
        },
        guardar_apoyo(){
            if (this.apoyo.length==0) {
                this.msg('error','No hay laborantes para agregar');
                return
            }
            //elimino los laborantes vacios
            this.apoyo = this.apoyo.filter(element => {
                return !(element.laborante.length == 0 && element.hora_inicio == '' && element.hora_fin == '');
            });
            let formData = new FormData();
            formData.append('apoyo', JSON.stringify(this.apoyo));
            axios.post('/api/guardar_laborantes_apoyo_oficina', formData).then(response => {
                this.laborantes_apoyo= response.data.apoyo;
                this.apoyo=[];
                if(this.apoyo.length==0){
                    this.agregar_lab_apoyo();
                }
                this.msg('success','Se han guardado los laborantes de apoyo.');
            });
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        valorpago(lab){
            axios.get('/api/get_pagos_periodo/'+lab.id).then(response => {
                this.liquido = response.data.total_liquido
                if (this.liquido>=250000) {
                    Swal.fire({
                        //position: "top-end",
                        icon: 'warning',
                        title: 'Laborante alcanzó limite de $250.000 en periodo '+this.formatFecha(response.data.inicio)+' al '+this.formatFecha(response.data.fin) ,
                        text: 'Tener en consideración para próximas actividades.',
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#C87838"
                        //showConfirmButton: false,
                        //timer: 5000
                    });
                }
            });
        }
    },
    mounted(){
        axios.get('/api/get_laborantes').then(response => {
            if (this.user.rol=='Admin') {
                this.laborantes= response.data.usuarios;
            }else {
                this.laborantes= response.data.usuarios.filter((us) => us.sede==this.user.sede);
            }
        });
        axios.get('/api/get_laborantes_apoyo_oficina').then(response => {
            if (this.user.rol=='Admin') {
                this.laborantes_apoyo= response.data.apoyo;
            }else if(this.user.rol=='Supervisor'){
                this.laborantes_apoyo= response.data.apoyo.filter((us) => us.sede==this.user.sede);
            }else if(this.user.rol=='Coordinador'){
                this.laborantes_apoyo= response.data.apoyo.filter((us) => us.user_id==this.user.id);
            }
        });
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card mt-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="offset-md-1 col-md-10">
                                <h5 class="text-primary mb-4">Agregar Laborantes Apoyo: </h5>
                                <div class="row mb-3 pb-2 shadow-sm" v-for="(lab,index) in apoyo" :key="index">
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Laborante:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <multiselect
                                                    v-model="lab.laborante"
                                                    :options="laborantes" 
                                                    placeholder="Seleccionar laborante" 
                                                    selectLabel="Presiona para seleccionar"
                                                    selectedLabel="Seleccionado"
                                                    deselectLabel="Presiona para remover"
                                                    :custom-label="labelselect_laborante"
                                                    @select="valorpago"
                                                    >
                                                    <template v-slot:noOptions>
                                                        <p>No hay opciones</p>
                                                    </template>
                                                    <template v-slot:noResult>
                                                        <p>No se encuentra coincidencia</p>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Fecha:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.fecha" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Hora inicio:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.hora_inicio" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Hora fin:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.hora_fin" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Comentario:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Campo Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <b-form-textarea v-model="lab.comentario" placeholder="" rows="3" max-rows="6" ></b-form-textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="offset-md-11 col-md-1">
                                        <b-button variant="danger" class="mt-2" @click="eliminar_apoyo(index)"><i class="bx bx-trash"></i></b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mb-3 text-right">
                                        <b-button class="" variant="primary" @click="agregar_lab_apoyo"><i class="bx bx-plus"></i>Laborante</b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <b-button variant="primary" block @click="guardar_apoyo()">Guardar Laborantes de Apoyo</b-button>
                                        <!-- <p class="text-primary mt-2">(**) Los laborantes permaneceran editables mientras no se paguen. Una vez se paguen, pasarán al listado de abajo.</p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card mt-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 5%;">Nº</th>
                                        <th style="width: 30%;">Nombre</th>
                                        <th style="width: 10%;">RUT</th>
                                        <th style="width: 10%;">Sede</th>
                                        <th style="width: 10%;">Fecha</th>
                                        <th style="width: 10%;">Hora inicio</th>
                                        <th style="width: 10%;">Hora fin</th>
                                        <!-- <th style="width: 20%;">Acción</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginatedData" :key="index">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.rut }}</td>
                                        <td>{{ item.sede }}</td>
                                        <td>{{ formatFecha(item.fecha) }}</td>
                                        <td>{{ item.hora_inicio }}</td>
                                        <td>{{ item.hora_fin }}</td>
                                        <!-- <td>
                                            
                                        </td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>